import { Grid2 as Grid, Skeleton } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { ViewTitle } from "@sinch/components";
import { FormSecondTitle } from "@sinch/components/typography/FormSecondTitle/FormSecondTitle";

export const SkeletonContainer = () => (
  <>
    <ViewTitle title={<Skeleton height={58} sx={{ mb: 2 }} width="30%" />} />
    <Grid container spacing={3}>
      {/* Personal Information Section */}
      {/* Divider */}
      <Grid size={12}>
        <FormSecondTitle title={<Skeleton height={36} variant="rectangular" width={150} />} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Skeleton height={56} variant="rectangular" />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Skeleton height={56} variant="rectangular" />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Skeleton height={56} variant="rectangular" />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Skeleton height={56} variant="rectangular" />
      </Grid>

      {/* Divider */}
      <Grid size={12}>
        <FormSecondTitle title={<Skeleton height={36} variant="rectangular" width={150} />} />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Skeleton height={56} variant="rectangular" />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Skeleton height={56} variant="rectangular" />
      </Grid>
      <Grid size={12}>
        <Skeleton height={56} variant="rectangular" />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Skeleton height={56} variant="rectangular" />
      </Grid>

      {/* Checkbox */}
      <Grid size={12}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Skeleton height={20} variant="rectangular" width={20} />
          <Skeleton height={20} width="50%" />
        </Box>
      </Grid>

      {/* Buttons */}
      <Grid size={12}>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-start" }}>
          <Skeleton height={42} variant="rectangular" width={100} />
          <Skeleton height={42} variant="rectangular" width={100} />
        </Box>
      </Grid>
    </Grid>
  </>
);
